"use client"

if (process.env.NODE_ENV === "development" && process.env["NEXT_PUBLIC_DISABLE_REACT_DEVTOOLS"] !== "1") {
  void import("react-grab")
  void import("react-scan")
}

export const DevTools = () => null
